import { patchRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function updateSingleSavedLoadPlanningSearchRequest(id, patch) {
	let url = savedLoadPlanningSearches.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
